import Vue from "vue";
import store from "./store";
// import {isMobile} from "mobile-device-detect";
import Router from "vue-router";
import NProgress from "nprogress";
// import checkAuth from "./system/auth/authenticate.js";
import checkSecPassword from "./auth/checkSecPassword";
Vue.use(Router);

// create new router

const routes = [
  {
    path: "/web",
    component: () => import("./views/menu"),
    redirect: "/web/homepage",
    children: [

      {
        path: "homepage",
        component: () => import("./views/homepage/homepage"),
      },
      {
        path: "rumble-result/:id",
        component: () => import("./views/homepage/rumbleResult"),
      },
      {
        path: "homepage2",
        component: () => import("./views/homepage/homepage2"),
      },
      {
        path: "rumble",
        component: () => import("./views/pages/live"),
      },
      {
        path: "live",
        component: () => import("./views/pages/live"),
      },
      {
        path: "product",
        component: () => import("./views/pages/mall"),
      },
      {
        path: "product/:id",
        component: () => import("./views/pages/product-detail"),
      },
      {
        path: "cart",
        component: () => import("./views/pages/cart"),
      },
      {
        path: "checkout",
        component: () => import("./views/pages/checkout"),
      },
      {
        path: "payment/:id",
        component: () => import("./views/pages/payment"),
      },
      // replaced by the new site's My Orders / order / Addresses pages
      { path: "orders", redirect: "/web/new/my-orders" },
      { path: "orders/:id", redirect: (to) => "/web/new/my-orders/" + to.params.id },
      {
        path: "invoice/:id",
        component: () => import("./views/pages/invoice"),
      },
      { path: "addresses", redirect: "/web/new/addresses" },
      { path: "wishlist", redirect: "/web/new/wishlist" },
      {
        path: "order-confirmed/:id",
        component: () => import("./views/pages/order-confirmed"),
      },
      // replaced by the new site's Rewards / Profile pages
      { path: "redeem", redirect: "/web/new/rewards" },
      { path: "profile", redirect: "/web/new/profile" },
      // {
      //   path: "dashboard",
      //   beforeEnter: checkAuth,
      //   component: () => import("./views/menu/dashboard"),
      // },
      // {
      //   path: "me",
      //   beforeEnter: checkAuth,
      //   component: () => import("./views/menu/me"),
      // },
      // {
      //   path: "notification",
      //   beforeEnter: checkAuth,
      //   component: () => import("./views/menu/notification"),
      // },

      {
        path: "/web/wallet",
        component: () => import("./views/app/transfer/wallet"),
      },
      {
        path: "/web/upgradePackage",
        component: () => import("./views/app/package/upgradePackage"),
      },
      {
        path: "/web/member",
        component: () => import("./views/app/team/member"),
      },

      {
        path: "/web/bonus/bonusRecord",
        component: () => import("./views/app/bonus/bonusRecord"),
      },
      
      {
        path: "/web/me/mePage",
        component: () => import("./views/app/me/profile"),
      },
      
      {
        path: "/web/me/invitation_link",
        component: () => import("./views/app/me/invitation_link"),
      },
      
      {
        path: "/web/me/news",
        component: () => import("./views/app/me/newsList"),
      },
      
      {
        path: "/web/me/basic_info",
        name: "basic_info",
        props: true,
        component: () => import("./views/app/me/basic_info"),
      },
      
      {
        path: "/web/me/newsDetails",
        name: "newDetails",
        props: true,
        component: () => import("./views/app/me/newsDetails"),
      },
      
      {
        path: "/web/me/KYC",
        component: () => import("./views/app/me/KYC"),
      },
      {
        path: "/web/me/password",
        component: () => import("./views/app/me/passwordSetting"),
      },

      

      // {
      //   path: "/web/chat",
      //   component: () => import("./views/app/chat"), //dashboard,
      //   children: [
      //     {
      //       path: "chatBox",
      //       component: () => import("./views/app/chat/chatBox"),
      //     },
      //   ]
      // },
      // {
      //   path: "/web/dashboard",
      //   beforeEnter: checkSecPassword,
      //   component: () => import("./views/app/dashboard"), //dashboard,
      //   children: [
      //     {
      //       path: "dashboard",
      //       component: () => import("./views/app/dashboard/dashboard"),
      //     },
      //   ]
      // },
      // {
      //   path: "/web/boost",
      //   beforeEnter: checkSecPassword,
      //   component: () => import("./views/app/boost"),
      //   children: [
      //     {
      //       path: "boostPage",
      //       component: () => import("./views/app/boost/boostPage"),

      //     },
      //   ]
      // },
      // {
      //   path: "/web/ticket",
      //   beforeEnter: checkSecPassword,
      //   component: () => import("./views/app/ticket/"),
      //   children: [
      //     {
      //       path: "createTicket",
      //       component: () => import("./views/app/ticket/createTicket"),

      //     },
      //   ]
      // },
      
      // {
      //   path: "/web/quantitative",
      //   component: () => import("./views/app/quantitative"), //dashboard,
      //   meta: { permission: '1' },
      //   children: [
      //     {
      //       path: "marketList",
      //       component: () => import("./views/app/quantitative/marketList"),

      //     },
      //     {
      //       path: "robotInfo",
      //       component: () => import("./views/app/quantitative/robotinfo"),

      //       props: true
      //     },
      //     {
      //       path: "robotSetting",
      //       component: () => import("./views/app/quantitative/robotSetting"),

      //       props: true
      //     },
      //   ]
      // },
      // {
      //   path: "/web/apiBinding",
      //   component: () => import("./views/app/apiBinding"),
      //   children: [
      //     {
      //       path: "apiBinding",
      //       component: () => import("./views/app/apiBinding/apiBinding"),

      //     },
      //   ]
      // },
      // {
      //   path: "/web/revenueManage",
      //   component: () => import("./views/app/revenueManage"),
      //   children: [
      //     {
      //       path: "revenue",
      //       component: () => import("./views/app/revenueManage/revenue"),

      //     },
      //     {
      //       path: "revenueDetails",
      //       component: () => import("./views/app/revenueManage/revenueDetails"),

      //     },
      //   ]
      // },
      // {
      //   path: "/web/myWallet",
      //   component: () => import("./views/app/myWallet"),
      //   children: [
      //     {
      //       path: "walletRecord",
      //       component: () => import("./views/app/myWallet/walletRecord"),

      //     },
      //     {
      //       path: "deposit",
      //       component: () => import("./views/app/myWallet/deposit"),

      //     },
      //     {
      //       path: "depositRecord",
      //       component: () => import("./views/app/myWallet/depositRecord"),

      //       props: true
      //     },
      //     {
      //       path: "withdraw",
      //       component: () => import("./views/app/myWallet/withdraw"),

      //       props: true
      //     },
      //     {
      //       path: "withdrawRecord",
      //       component: () => import("./views/app/myWallet/withdrawRecord"),

      //       props: true
      //     },
      //     {
      //       path: "transfer",
      //       component: () => import("./views/app/myWallet/transfer"),

      //       props: true
      //     },
      //     {
      //       path: "transferRecord",
      //       component: () => import("./views/app/myWallet/transferRecord"),

      //       props: true
      //     },
      //   ]
      // },
      // // settings
      // {
      //   path: "/web/settings",
      //   beforeEnter: checkSecPassword,
      //   component: () => import("./views/app/settings"),
      //   children: [
      // {
      //   path: "settingCenter",
      //   component: () => import("./views/app/settings/settingCenter")
      // },
      // {
      //   path: "change-password",
      //   meta: { permission: '111' },
      //   component: () => import("./views/app/settings/change-password")
      // },
      // {
      //   path: "change-sec-password",
      //   component: () => import("./views/app/settings/change-sec-password"),

      //   props: true
      // },
      // {
      //   path: "forget-sec-password",
      //   component: () => import("./views/app/settings/forget-sec-password"),

      //   props: true
      // },
      //   ]
      // },
    ]
  },
  // {
  //   path: "/web/voucherList",
  //   name: 'voucherList',
  //   props: true,
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/voucher/voucherList"),
  // },
  // {
  //   path: "/web/product/details",
  //   name: 'productDetails',
  //   props: true,
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/details"),
  // },
  // {
  //   path: "/web/hotel/hoteldetails",
  //   name: 'hotelDetails',
  //   props: true,
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/hotel/detailsHotel"),
  // },
  // {
  //   path: "/web/hotel/cartHotel",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/hotel/cartHotel"),
  // },
  // {
  //   path: "/web/hotel/checkoutHotel",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/hotel/checkoutHotel"),
  // },
  // {
  //   path: "/web/hotel/orderHotelHistory",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/hotel/orderHotelHistory"),
  // },
  // {
  //   path: "/web/hotel/orderHotelDetails",
  //   // beforeEnter: checkAuth,
  //   name: "orderHotelDetials",
  //   component: () => import("./views/hotel/orderHotelDetails"),
  // },
  // {
  //   path: "/web/product/cart",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/cart"),
  // },
  // {
  //   path: "/web/product/address",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/address"),
  // },
  // {
  //   path: "/web/product/create-address",
  //   // name: 'addaddress', props: true,
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/createAddress.vue"),
  // },
  // {
  //   path: "/web/product/addaddress",
  //   name: 'addaddress', props: true,
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/addAddress"),
  // },
  // {
  //   path: "/web/product/checkout",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/checkout"),
  // },
  // {
  //   path: "/web/product/orderHistory",
  //   beforeEnter: checkAuth,
  //   component: () => import("./views/product/orderHistory"),
  // },
  // {
  //   path: "/web/product/orderDetails",
  //   // beforeEnter: checkAuth,
  //   name: "orderDetials",
  //   component: () => import("./views/product/orderDetails"),
  // },
  // {
  //   path: "/web/product/tracking",
  //   beforeEnter: checkAuth,
  //   name: "tracking",
  //   component: () => import("./views/product/tracking"),
  // },

  // New site (built page by page, old pages stay untouched). Renders without the old
  // Header/Footer — App.vue skips them for any path under /web/new.
  {
    path: "/web/new",
    component: () => import("./views/newsite/homeNew"),
  },
  {
    path: "/web/new/product",
    component: () => import("./views/newsite/productNew"),
  },
  {
    path: "/web/new/product/:id",
    component: () => import("./views/newsite/productDetailNew"),
  },
  {
    path: "/web/new/about",
    component: () => import("./views/newsite/aboutNew"),
  },
  {
    path: "/web/new/event",
    component: () => import("./views/newsite/eventNew"),
  },
  {
    path: "/web/new/event/:id",
    component: () => import("./views/newsite/eventDetailNew"),
  },
  {
    path: "/web/new/results",
    component: () => import("./views/newsite/resultsNew"),
  },
  {
    path: "/web/new/results/:id",
    component: () => import("./views/newsite/resultDetailNew"),
  },
  {
    path: "/web/new/rip-games",
    component: () => import("./views/newsite/ripGames"),
  },
  // Full-screen live page (no header/footer; opened from the LIVE carousel slide)
  {
    path: "/web/new/live",
    component: () => import("./views/newsite/liveNew"),
  },
  // Sign in (the Profile tab opens it when nobody is logged in)
  {
    path: "/web/new/login",
    component: () => import("./views/newsite/loginNew"),
  },
  {
    path: "/web/new/forgot-password",
    component: () => import("./views/newsite/forgotNew"),
  },
  {
    path: "/web/new/sign-up",
    component: () => import("./views/newsite/signupNew"),
  },
  {
    path: "/web/new/cart",
    component: () => import("./views/newsite/cartNew"),
  },
  {
    path: "/web/new/checkout",
    component: () => import("./views/newsite/checkoutNew"),
  },
  {
    // order placed (success page) / something went wrong (?reason=…)
    path: "/web/new/order/:id",
    component: () => import("./views/newsite/orderResultNew"),
  },
  {
    path: "/web/new/order-failed",
    component: () => import("./views/newsite/orderResultNew"),
  },
  // the Profile and Rewards tabs (the old /web/profile and /web/redeem send people here)
  {
    path: "/web/new/profile",
    component: () => import("./views/newsite/profileNew"),
  },
  {
    path: "/web/new/rewards",
    component: () => import("./views/newsite/rewardsNew"),
  },
  // reached from Profile (the old /web/orders and /web/addresses send people here)
  {
    path: "/web/new/my-orders",
    component: () => import("./views/newsite/ordersNew"),
  },
  {
    path: "/web/new/my-orders/:id",
    component: () => import("./views/newsite/orderDetailNew"),
  },
  {
    path: "/web/new/addresses",
    component: () => import("./views/newsite/addressesNew"),
  },
  {
    path: "/web/new/wishlist",
    component: () => import("./views/newsite/wishlistNew"),
  },
  {
    path: "/web/package",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/package"),
    redirect: "/web/package/packageHistory",
    children: [
      {
        path: "packageHistory",
        component: () => import("./views/app/package/packageHistory"),
      },
    ]
  },
  {
    path: "/web/wallet/record",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/transfer/walletRecord"),
  },
  {
    path: "/web/wallet/recordDetails",
    name: "recordDetails",
    props: true,
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/transfer/recordDetails"),
  },
  {
    path: "/web/transfer",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/transfer"),
    redirect: "/web/transfer/transfer",
    children: [
      {
        path: "transfer",
        component: () => import("./views/app/transfer/transfer"),
      },
      {
        path: "register",
        component: () => import("./views/sessions/register"),
      },
      {
        path: "set_secpassword",
        component: () => import("./views/sessions/set_secpassword"),
      },
      {
        path: "changeWallet",
        component: () => import("./views/app/transfer/changeWallet"),
      },
    ]
  },
  {
    path: "/web/insurance",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/insurance"),
    redirect: "/web/insurance/purchaseInsurance",
    children: [
      {
        path: "purchaseInsurance",
        component: () => import("./views/app/insurance/purchaseInsurance"),
      },
      {
        path: "insuranceRecord",
        component: () => import("./views/app/insurance/insuranceRecord"),
      },
      {
        path: "claimInsuranceHis",
        component: () => import("./views/app/insurance/claimInsuranceHis"),
      },
    ]
  },
  {
    path: "/web/bonus",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/bonus"),
    redirect: "/web/bonus/bonusCenter",
    children: [
      {
        path: "bonusCenter",
        component: () => import("./views/app/bonus/bonusCenter"),
      },
      {
        path: "/web/bonus/bonusRecord",
        beforeEnter: checkSecPassword,
        component: () => import("./views/app/bonus/bonusRecord"),
      },
    ]
  },
  {
    path: "/web/withdraw",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/withdraw"),
    redirect: "/web/withdraw/withdraw",
    children: [
      {
        path: "withdraw",
        component: () => import("./views/app/withdraw/withdraw"),
      },
      {
        path: "withdrawHistory",
        component: () => import("./views/app/withdraw/withdrawHistory"),
      },
    ]
  },
  // {
  //   path: "/web/myTeam",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/team/memberTree"),
  // },
  // {
  //   path: "/web/requestDeposit",
  //   beforeEnter: checkRequestDeposit,
  //   component: () => import("./views/app/deposit/requestDeposit"),
  // },
  {
    path: "/web/deposit",
    beforeEnter: checkSecPassword,
    component: () => import("./views/app/deposit"),
    redirect: "/web/deposit/deposit",
    children: [
      {
        path: "deposit",
        component: () => import("./views/app/deposit/deposit"),
      },
      {

        path: "depositHistory",
        component: () => import("./views/app/deposit/depositHistory"),
      },
    ]
  },
  // {
  //   path: "/web/withdraw",
  //   component: () => import("./views/app/withdraw"),
  //   beforeEnter: checkSecPassword,
  //   redirect: "/web/withdraw/withdraw",
  //   children: [
  //     {
  //       path: "withdraw",
  //       beforeEnter: checkInfo,
  //       component: () => import("./views/app/withdraw/withdraw"),
  //     },
  //     {
  //       path: "setBank",
  //       component: () => import("./views/app/withdraw/setBank"),
  //     },
  //     {

  //       path: "withdrawHistory",
  //       component: () => import("./views/app/withdraw/withdrawHistory"),
  //     },
  //   ]
  // },

  // {
  //   path: "/web/boost/boostPage",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/boost/boostPage"),
  // },
  // {
  //   path: "/web/settings/settingCenter",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/settings/settingCenter"),
  // },
  // {
  //   path: "/web/settings/change-password",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/settings/change-password"),
  // },
  {
    path: "/web/settings/forget-password",
    component: () => import("./views/app/settings/forget-password"),
  },
  // {
  //   path: "/web/settings/change-sec-password",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/settings/change-sec-password"),
  // },
  // {
  //   path: "/web/settings/forget-sec-password",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/settings/forget-sec-password"),
  // },
  {
    path: "/web/settings/set-sec-password",
    component: () => import("./views/app/settings/set-sec-password"),
  },
  // {
  //   path: "/web/bonus/bonusCenter",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/bonus/bonusCenter"),
  // },
  // {
  //   path: "/web/bonus/bonusRecord",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/bonus/bonusRecord"),
  // },
  // {
  //   path: "/web/bonus/dynamicBonusRecord",
  //   beforeEnter: checkSecPassword,
  //   component: () => import("./views/app/bonus/dynamicBonusRecord"),
  // },



  // sessions
  {
    path: "/web/sessions",
    component: () => import("./views/app/sessions"),
    redirect: "/web/sessions/signIn",
    children: [
      {
        path: "signIn",
        component: () => import("./views/app/sessions/signIn")
      },
      // {
      //   path: "signUp",
      //   component: () => import("./views/app/sessions/signUp")
      // },
      // {
      //   path: "forgot",
      //   component: () => import("./views/app/sessions/forgot")
      // }
    ]
  },

  {
    // the old template sign-up (it saved a token nothing else reads) → the new page
    path: "/register",
    redirect: (to) => ({ path: "/web/new/sign-up", query: to.query }),
  },

  // The header, checkout, orders, invoice and redeem pages send customers to these three, but
  // the routes were lost in the 2025-04-18 router change and they showed "not found".
  // Login, register and forgot password now all go to the new pages (keeping ?redirect=…).
  {
    path: "/web/sessions/login",
    redirect: (to) => ({ path: "/web/new/login", query: to.query }),
  },
  {
    path: "/web/sessions/register",
    redirect: (to) => ({ path: "/web/new/sign-up", query: to.query }),
  },
  {
    // the new page; the old one called a reset that never checked the emailed code
    path: "/web/sessions/forget_password",
    redirect: "/web/new/forgot-password",
  },

  // {
  //   path: "/vertical-sidebar",
  //   component: () => import("./containers/layouts/verticalSidebar")
  // },
  {
    path: "*",
    component: () => import("./views/app/pages/notFound")
  }
];

const router = new Router({
  mode: "history",
  linkActiveClass: "open",
  routes,
  // to, from, savedPosition
  scrollBehavior() {
    return { x: 0, y: 0 };
  }
});

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  if (to.path) {
    // Start the route progress bar.

    NProgress.start();
    NProgress.set(0.1);
  }
  // if (localStorage.getItem('path') != null) {
  //   var permissionList = localStorage.getItem('path');
  //   console.log((permissionList.includes(to.meta.permission)))
  //   try {
  //     // if (to.path == '/') {
  //     //   next('/');
  //     // }

  //     if (to.meta.permission != undefined && to.path != '/*') {
  //       if(permissionList.includes(to.meta.permission)){
  //         next();

  //       }else{
  //         next('*');
  //       }
  //     } else {
  //       next();
  //     }

  //   } catch (error) {
  //     console.log(error)
  //   }

  // } else {
  //   localStorage.removeItem("boostToken");

  // }
  next();
});

router.afterEach(() => {
  // Remove initial loading
  const gullPreLoading = document.getElementById("loading_wrap");
  if (gullPreLoading) {
    gullPreLoading.style.display = "none";
  }
  // Complete the animation of the route progress bar.
  setTimeout(() => NProgress.done(), 100);
  // NProgress.done();
  // if (isMobile) {
  if (window.innerWidth <= 1200) {
    // console.log("mobile");
    store.dispatch("changeSidebarProperties");
    if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
      store.dispatch("changeSecondarySidebarProperties");
    }
  } else {
    if (store.getters.getSideBarToggleProperties.isSecondarySideNavOpen) {
      store.dispatch("changeSecondarySidebarProperties");
    }

    // store.state.sidebarToggleProperties.isSecondarySideNavOpen = false;
  }
});

export default router;
